import * as Actions from "../../actions/app"

const initialState = {
  loading_items_by_purchase: false,
  items_by_purchase: [],
}

const purchaseItemsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ITEMS_BY_PURCHASE_ID: {
      return {
        ...state,
        loading_items_by_purchase: action.payload.loading,
        items_by_purchase: action.payload.data ?? state.items_by_purchase,
      }
    }
    default: {
      return state
    }
  }
}
export default purchaseItemsReducer
